//import 'bootstrap/dist/css/bootstrap.css';

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { LocalizeProvider } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server';

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

ReactDOM.render(
  <LocalizeProvider>
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  </LocalizeProvider>,
  rootElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js